import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Campaign3KontableComponent } from '../../campaign-3-kontable/campaign-3-kontable.component';
import { Campaign3Service } from 'app/views/campaign-3/services/campaign3.service';
import { CouponService } from 'app/services/campaign/coupon.service';
import { setTimeout } from 'timers';
@Component({
  selector: 'app-campaign-3-view-coupons',
  templateUrl: './campaign-3-view-coupons.component.html',
  styleUrls: ['./campaign-3-view-coupons.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Campaign3ViewCouponsComponent implements OnInit {
  
  @Input() filters: Array<{key: string, value: string}> = [];
  @Input() dateFormat: string = "dd/MM/yyyy";
  @Input() messageInstanceId: number = null;

  @ViewChild('couponTable') couponTable: Campaign3KontableComponent

  title: string = "Coupon";
  paginationType: number = Campaign3KontableComponent.ServerPagination;
  dateFilter = Campaign3KontableComponent.DateFilter;
  showEditForm = false;
  couponToEdit: any;
  
  show = {
    table: false
  }
  
  constructor(
    private couponService: CouponService
  ) {
    
  }

  ngOnInit() {
    this.couponService.messageInstanceId = this.messageInstanceId.toString();
    this.show.table = true;
    var self = this;
    setTimeout(function(){
      self.couponTable.refresh();
    },100);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/view-coupons/campaign-3-view-coupons.component.ts